import { cn } from "@/infrastructure/adapters/classnames";

import { PRIORITY_COLORS, PriorityKey,   VALIDITY_COLORS, ValidityKey } from "./IDeductionChips";
import { IStyles } from "@/core/entities/lookup";

const getProgressChipClassName = (selectedStyles: IStyles, withBorder: boolean, withBackground: boolean): string => {
    const classNames = cn(
        `text-${selectedStyles?.color}`,
        withBorder ? `border border-color-${selectedStyles?.border}` : "border-none",
        withBackground ? `bg-${selectedStyles?.bg}` : ""
    );
    return classNames;
};

const getPriorityChipClassName = (priorityKey: PriorityKey, withBorder: boolean, withBackground: boolean): string => {
    const colors = PRIORITY_COLORS[priorityKey];
    const classNames = cn(
        `text-${colors.text}`,
        withBorder ? `border border-color-${colors.border}` : "border-none p-0",
        withBackground ? `bg-${colors.bg}` : ""
    );
    return classNames;
};

const getValidityChipClassName = (validityKey: ValidityKey, withBorder: boolean, withBackground: boolean): string => {
    const colors = VALIDITY_COLORS[validityKey];
    const classNames = cn(
        `text-${colors.text}`,
        withBorder ? `border border-color-${colors.border}` : "border-none p-0",
        withBackground ? `bg-${colors.bg}` : ""
    );
    return classNames;
};

const CLOSED_AGE_CHIP_COLORS = {
  text: "grey-600",
  bg: "grey-25",
  border: "grey-100",
};

const getAgeChipClassName = (
  priorityKey: PriorityKey,
  withBorder: boolean,
  withBackground: boolean,
  isClosed = false
): string => {
  const colors = isClosed ? CLOSED_AGE_CHIP_COLORS : PRIORITY_COLORS[priorityKey];
  const classNames = cn(
    `text-${colors.text}`,
    withBorder ? `border border-color-${colors.border}` : "border-none",
    withBackground ? `bg-${colors.bg}` : ""
  );
  return classNames;
};


export {
    getProgressChipClassName,
    getPriorityChipClassName,
    getValidityChipClassName,
    getAgeChipClassName,
}
